import { Link, Image, Box, Flex, useClipboard, useToast } from '@chakra-ui/react';

import CopyInversedIcon from 'public/icons/copy_inversed_icon.svg';
import FacebookInversedIcon from 'public/icons/facebook_inversed_icon.svg';
import TwitterInversedIcon from 'public/icons/twitter_inversed_icon.svg';

interface Props {
  title: string;
  url: string;
}

const buttonSpCss = {
  borderRadius: 'full',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  w: '48px',
  h: '48px',
  boxShadow: '0px 4px 12px rgba(15, 20, 36, 0.12)',
};

export const ShareSticky: React.FC<Props> = ({ title, url }) => {
  const { onCopy } = useClipboard(url);
  const toast = useToast();

  const handleCopyToClipboard = () => {
    onCopy();
    toast({
      position: 'bottom',
      duration: 3000,
      // eslint-disable-next-line
      render: () => (
        <Box color="white" mb="32px" p="21.5px 32px" bg="rgba(15, 20, 36, 0.87)" borderRadius={8}>
          URLをコピーしました
        </Box>
      ),
    });
  };

  return (
    <Flex
      display={{ base: 'block', md: 'none' }}
      position="sticky"
      pb="24px"
      pr="24px"
      right="0"
      bottom="0"
      left="0"
      zIndex="100"
      w="100%"
      textAlign="right"
    >
      <Box display="inline-block">
        <Box as="button" onClick={handleCopyToClipboard} bgColor="#7890dd" sx={buttonSpCss}>
          <Image src={CopyInversedIcon} alt="クリップボードにコピー" />
        </Box>
      </Box>
      <Box marginLeft="8px" display="inline-block">
        <Link
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          target="_blank"
          rel="nofollow noreferrer"
          bgColor="#217cef"
          sx={buttonSpCss}
        >
          <Image src={FacebookInversedIcon} alt="Facebookでシェア" />
        </Link>
      </Box>
      <Box marginLeft="8px" display="inline-block">
        <Link
          href={`https://twitter.com/intent/tweet?text=${title}&url=${url}&hashtags=shizai`}
          target="_blank"
          rel="nofollow noreferrer"
          bgColor="#1b9ff4"
          sx={buttonSpCss}
        >
          <Image src={TwitterInversedIcon} alt="TwitterでTweet" />
        </Link>
      </Box>
    </Flex>
  );
};
